import type { Story } from 'types/api/story'

export function collectStoryPrefetchUrls(
  stories: Story[]
): string[] {
  const urls = new Set<string>()

  for (const story of stories) {
    if (story.image_src_thumb) {
      urls.add(story.image_src_thumb)
    }

    if (story.image_src) {
      urls.add(story.image_src)
    }

    if (story.video_thumb_src) {
      urls.add(story.video_thumb_src)
    }
  }

  return Array.from(urls)
}